<template>
  <div class="privacy-policy">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1>Privacy Policy</h1>
          <p class="effective-date">Effective Date: 20 July 2026</p>

          <p>
            Welcome to
            <a href="https://tbs.com.my">tbs.com.my</a>
            ("Website", "we", "our", or "us"). We are committed to protecting
            your privacy and ensuring that your personal information is handled
            responsibly. This Privacy Policy explains how we collect, use,
            disclose, and protect your information when you visit our website.
          </p>

          <h2>1. Information We Collect</h2>

          <h3>Personal Information</h3>
          <p>
            We may collect personal information that you voluntarily provide,
            including:
          </p>
          <ul>
            <li>Full name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Company name</li>
            <li>Mailing address</li>
            <li>Any information you submit through our contact forms</li>
          </ul>

          <h3>Automatically Collected Information</h3>
          <p>When you access our website, we may automatically collect:</p>
          <ul>
            <li>IP address</li>
            <li>Browser type and version</li>
            <li>Device information</li>
            <li>Operating system</li>
            <li>Pages visited</li>
            <li>Date and time of your visit</li>
            <li>Referring website</li>
            <li>General location (based on IP address)</li>
          </ul>

          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide and improve our services</li>
            <li>Respond to your inquiries and requests</li>
            <li>Process transactions (if applicable)</li>
            <li>
              Send updates, newsletters, or marketing communications (only with
              your consent where required)
            </li>
            <li>Analyze website traffic and performance</li>
            <li>Detect, prevent, and investigate security issues or fraud</li>
            <li>Comply with legal obligations</li>
          </ul>

          <h2>3. Cookies and Tracking Technologies</h2>
          <p>
            Our website may use cookies and similar technologies to:
          </p>
          <ul>
            <li>Remember your preferences</li>
            <li>Improve website functionality</li>
            <li>Analyze visitor traffic</li>
            <li>Enhance user experience</li>
          </ul>
          <p>
            You can configure your browser to refuse or delete cookies. Some
            features of the website may not function properly if cookies are
            disabled.
          </p>

          <h2>4. Third-Party Services</h2>
          <p>
            We may use trusted third-party service providers to support our
            website and business operations, such as:
          </p>
          <ul>
            <li>Website hosting providers</li>
            <li>Analytics services</li>
            <li>Email marketing platforms</li>
            <li>Payment processors (if applicable)</li>
            <li>Customer support tools</li>
          </ul>
          <p>
            These providers may access personal information only as necessary to
            perform services on our behalf and are required to protect your
            information.
          </p>

          <h2>5. Sharing Your Information</h2>
          <p>We do not sell or rent your personal information.</p>
          <p>We may share your information only when:</p>
          <ul>
            <li>Required by law or legal process</li>
            <li>Necessary to protect our legal rights</li>
            <li>Required to investigate fraud or security issues</li>
            <li>
              Working with trusted service providers under confidentiality
              obligations
            </li>
            <li>Part of a business merger, acquisition, or sale of assets</li>
          </ul>

          <h2>6. Data Security</h2>
          <p>
            We implement reasonable administrative, technical, and physical
            safeguards to protect your personal information against unauthorized
            access, disclosure, alteration, or destruction.
          </p>
          <p>
            While we strive to protect your information, no method of electronic
            transmission or storage is completely secure. Therefore, we cannot
            guarantee absolute security.
          </p>

          <h2>7. Data Retention</h2>
          <p>
            We retain personal information only for as long as necessary to:
          </p>
          <ul>
            <li>Provide our services</li>
            <li>Meet legal and regulatory requirements</li>
            <li>Resolve disputes</li>
            <li>Enforce our agreements</li>
          </ul>
          <p>
            After this period, information will be securely deleted or
            anonymized where appropriate.
          </p>

          <h2>8. Your Privacy Rights</h2>
          <p>
            Depending on your location and applicable laws, you may have the
            right to:
          </p>
          <ul>
            <li>Access your personal information</li>
            <li>Correct inaccurate information</li>
            <li>Request deletion of your information</li>
            <li>Restrict or object to processing</li>
            <li>Withdraw consent at any time</li>
            <li>Request a copy of your personal data where applicable</li>
          </ul>
          <p>
            To exercise these rights, please contact us using the information
            below.
          </p>

          <h2>9. Children's Privacy</h2>
          <p>
            Our website is not directed toward children under the age required
            by applicable law. We do not knowingly collect personal information
            from children.
          </p>
          <p>
            If we become aware that a child has provided personal information,
            we will take appropriate steps to remove it.
          </p>

          <h2>10. Third-Party Links</h2>
          <p>
            Our website may contain links to external websites operated by third
            parties. We are not responsible for the privacy practices or content
            of those websites. We encourage you to review their privacy policies
            before providing personal information.
          </p>

          <h2>11. International Data Transfers</h2>
          <p>
            If your information is transferred or processed outside your country
            of residence, we will take reasonable steps to ensure it receives an
            appropriate level of protection in accordance with applicable data
            protection laws.
          </p>

          <h2>12. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Any changes will
            be posted on this page with a revised Effective Date. Continued use
            of the website after changes become effective constitutes acceptance
            of the updated Privacy Policy.
          </p>

          <h2>13. Contact Us</h2>
          <p>
            If you have any questions, concerns, or requests regarding this
            Privacy Policy or how we handle your personal information, please
            contact us:
          </p>
          <address class="contact-block">
            <strong>TBS Solutions Sdn Bhd</strong><br />
            Website:
            <a href="https://tbs.com.my">https://tbs.com.my</a><br />
            Email: <a href="mailto:tbs@tbs.com.my">tbs@tbs.com.my</a><br />
            Phone: <a href="tel:+6043998789">+60 4-399 8789</a><br />
            Address: 20B Jalan Todak 5, Pusat Bandar Seberang Jaya, 13700
            Seberang Jaya, Penang, Malaysia.
          </address>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy"
};
</script>

<style scoped>
.privacy-policy {
  padding: 50px 0 60px;
}

.privacy-policy h1 {
  margin-bottom: 8px;
}

.privacy-policy .effective-date {
  color: #777;
  margin-bottom: 30px;
}

.privacy-policy h2 {
  font-size: 1.4rem;
  margin-top: 35px;
  margin-bottom: 12px;
}

.privacy-policy h3 {
  font-size: 1.1rem;
  margin-top: 20px;
  margin-bottom: 10px;
}

.privacy-policy p,
.privacy-policy li {
  line-height: 1.7;
}

.privacy-policy ul {
  margin-bottom: 15px;
  padding-left: 20px;
}

.privacy-policy .contact-block {
  line-height: 1.8;
  margin-top: 15px;
}
</style>